import WorkflowModel from '@opsbase/lib-data-model/models/WorkflowModel';
import DataType from '@opsbase/lib-datatype/DataType/DataType';
import Event from '@opsbase/lib-event';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import useWorkflowCreate from '@opsbase/react-gql-hooks/workflow/useWorkflowCreate';
import i18n from '@opsbase/lib-i18n';
import useCss from '@opsbase/web-css';
import CreateDialog from '@opsbase/web-dialogs/CreateDialog';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import EventTypePicker from '@opsbase/web-pickers/EventTypePicker';
import TextFieldWithStateAndBlur from '@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur';
import React, { useCallback, useState } from 'react';
import WorkflowSchedule from "@opsbase/lib-workflow/WorkflowSchedule";
const makeMyClasses = () => ({
    workflow: {
        border: `1px solid ${Palette.LineGrey.main}`,
        borderRadius: 8,
        padding: 8,
        backgroundColor: 'white',
        margin: '4px 0',
        height: 'auto',
    },
    textField: {
        backgroundColor: Palette.White.main,
    },
});
export function WorkflowPickTriggerDialog() {
    const { newWorkflow = {}, dataType = DataType.ISSUE } = useParams();
    const [workflow, setWorkflow] = useState(new WorkflowModel(newWorkflow));
    const { raise } = useNotificationActions();
    const { goBack, goTo } = useNav();
    const createWorkflow = useWorkflowCreate();
    const myCss = useCss(makeMyClasses);
    const handleCreateWorkflow = useCallback(() => {
        return raise(createWorkflow({
            patch: { ...workflow, enabled: true },
        }), i18n.t('workflow-create-successful'));
    }, [raise, createWorkflow, workflow]);
    const handleAfterCreate = useCallback(({ id }) => {
        goBack();
        setTimeout(() => goTo(Pages.WORKFLOWS_EDIT, { id }), 500);
    }, [goTo, goBack]);
    const setEvent = useCallback((e) => {
        if (e !== workflow.event) {
            setWorkflow(new WorkflowModel({
                ...workflow,
                event: e,
                schedule: e === Event.SCHEDULE ? new WorkflowSchedule() : undefined
            }));
        }
    }, [setWorkflow, workflow]);
    const handleChangeTitle = useCallback(title => {
        setWorkflow(new WorkflowModel({
            ...workflow,
            title: title,
        }));
    }, [setWorkflow, workflow]);
    return (React.createElement(CreateDialog, { padded: false, title: i18n.t('create-workflow'), scroll: true, valid: !!(workflow === null || workflow === void 0 ? void 0 : workflow.event) && !!(workflow === null || workflow === void 0 ? void 0 : workflow.title), afterCreate: handleAfterCreate, onCreate: handleCreateWorkflow },
        React.createElement(Vertical, { shrink: true, style: {
                marginLeft: 32,
                marginRight: 32,
                backgroundColor: Palette.BackgroundGrey.main,
            }, classes: { root: myCss.workflow }, gutter: true },
            React.createElement(TextFieldWithStateAndBlur, { className: myCss.textField, fullWidth: true, placeholder: i18n.t('title'), onBlur: handleChangeTitle, value: workflow === null || workflow === void 0 ? void 0 : workflow.title }),
            React.createElement(EventTypePicker, { white: true, dataType: dataType, value: workflow === null || workflow === void 0 ? void 0 : workflow.event, onChange: setEvent, placeholder: i18n.t('pick-an-workflow-trigger') }))));
}
export default WorkflowPickTriggerDialog;
